<div class="header-cont flex py-6 mobile:p-3 ">
    
    <div class="flex items-center">
        <img class="h-16 cursor-pointer" src="assets/logos/gwc-regalia-hire-logo.png" (click)="goToMainSite()">
    </div>

    <div class="flex justify-end flex-grow">

        <!-- <div class="hidden mobile:block mobile:flex mobile:items-center">
            <mat-icon>menu</mat-icon>
        </div>

        <div *ngFor="let item of mainMenuItems" class="flex items-center mobile:hidden">
            <div class="pl-7" [ngClass]="{'button': item.display === 'Hire Regalia'}">
                <a (click)="itemClicked(item.url)" class="cursor-pointer hover:text-gwc-primary-red">
                    {{ item.display }}
                </a>    
            </div>
        </div> -->

    </div>

</div>